export default {
    XML : {id:'xml',desc:'XML'},
    JSON : {id:'json',desc:'JSON'},
    TREE : {id:'TREE',desc:'TREE'}
}